const BaseElement = require('./element.base')

const CheckboxElement = BaseElement.extend({

    elementEvents: {
        'change:checked': 'validateElement',
    },

})

module.exports = CheckboxElement
